export enum Transport {
  None = "None",
  MSMQ = "MSMQ",
  AzureStorageQueue = "AzureStorageQueue",
  NetStandardAzureServiceBus = "AzureServiceBus",
  LearningTransport = "LearningTransport",
  RabbitMQ = "RabbitMQ",
  SQLServer = "SqlTransport",
  AmazonSQS = "AmazonSQS",
  PostgreSQL = "PostgreSql",
}
